import { render, staticRenderFns } from "./IndustryTags.vue?vue&type=template&id=3e44921a&scoped=true"
import script from "./IndustryTags.vue?vue&type=script&lang=js"
export * from "./IndustryTags.vue?vue&type=script&lang=js"
import style0 from "./IndustryTags.vue?vue&type=style&index=0&id=3e44921a&prod&scoped=true&lang=css"
import style1 from "./IndustryTags.vue?vue&type=style&index=1&id=3e44921a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e44921a",
  null
  
)

export default component.exports